import React from 'react'
import props from 'prop-types'

const NAVBAR = (props) => {
  return (
    <div>
      <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
  <a className="navbar-brand" href="#">{props.title}</a>
  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon"></span>
  </button>

  <div className="collapse navbar-collapse" id="navbarSupportedContent">
    <ul className="navbar-nav me-auto mb-2 mb-lg-0 ">
    </ul>
  

<div className={`form-check form-switch text-${props.mode ==='light'?'dark':'light'}`}>
  <input className="form-check-input" onClick={props.toggleMode} type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
  <label className={`form-check-label `}  htmlfor="flexSwitchCheckDefault" >Enable {`${props.mode ==='light'?'dark':'light'}`} mode</label>
</div>
  </div>
</nav>
    </div>
  )
}

export default NAVBAR

NAVBAR.props={
  title:props.string.isRequired,
      aboutText:props.string
        }